module.exports = __webpack_public_path__ + "assets/img/The-Onset-Website-w720.f26464fa.jpg";